import { requestbody } from './request.js';

// 申报异步任务调用记录分页查询
export async function structuralDataPage(params = {}, page = {}) {
  const current = encodeURIComponent(page.current || 1);
  const size = encodeURIComponent(page.size || 50);
  return await requestbody(
    `/structuralData/page?current=${current}&size=${size}`,
    'post',
    params
  );
}

// 发起结构化数据请求
export async function issueStructuralDataRequest(params = {}) {
  return await requestbody('/structuralData/issueRequest', 'post', params);
}
